export const PRESCRIBE_ORDER_OPTIONS = {
  true: { value: "true", label: "Submit prescription order for a medication" },
  false: { value: "false", label: "Do not submit a prescription order" },
} as const;

export const PRESCRIBE_ORDER_VALUES = [
  PRESCRIBE_ORDER_OPTIONS.true,
  PRESCRIBE_ORDER_OPTIONS.false,
] as const;
